import React from "react";
import { Row, Col } from "react-bootstrap";
import { CommonButton, CommonModal } from "../Input";

const DetailField = ({ label, value }) => (
  <div className="mb-4 pe-3">
    <label
      className="fs-12 mb-2 d-block fw-medium"
      style={{ color: "#6c757d" }}
    >
      {label}
    </label>
    <div
      className="text-black fw-bold fs-15"
      style={{ wordBreak: "break-word", lineHeight: "1.4" }}
    >
      {value || "-"}
    </div>
  </div>
);

const SectionContainer = ({ title, children }) => (
  <div className="mb-4">
    <h6 className="fw-bold mb-3 fs-14" style={{ color: "#6c757d" }}>
      {title}
    </h6>
    <div
      className="border p-4 h-100"
      style={{ borderRadius: "12px", backgroundColor: "#fafafa" }}
    >
      <Row>{children}</Row>
    </div>
  </div>
);

const BeneficiaryDetailsModal = ({ show, onHide, beneficiary }) => {
  if (!beneficiary) return null;

  return (
    <CommonModal
      show={show}
      onHide={onHide}
      size="xl"
      title="Beneficiary Details"
      headerClassName="border-bottom pb-3"
      footer={
        <div className="w-100 text-end">
          <CommonButton variant="outline" onClick={onHide}>
            Close
          </CommonButton>
        </div>
      }
    >
      <Row>
        {/* Left Column */}
        <Col lg={6}>
          <SectionContainer title="Basic information">
            <Col md={6}>
              <DetailField
                label="Country"
                value={beneficiary.details?.country || "Singapore"}
              />
            </Col>
            <Col md={6}>
              <DetailField
                label="Currency"
                value={beneficiary.details?.currency || "SGD"}
              />
            </Col>
            <Col md={6}>
              <DetailField
                label="Receiver type"
                value={beneficiary.receiverType}
              />
            </Col>
            <Col md={6}>
              <DetailField
                label="Receiving method"
                value={beneficiary.receivingMethod || beneficiary.details?.receivingMethod}
              />
            </Col>
            <Col md={6}>
              <DetailField
                label="Relationship to sender"
                value={beneficiary.details?.relationship || beneficiary.relationship}
              />
            </Col>
          </SectionContainer>

          <SectionContainer title="ID information">
            <Col md={6}>
              <DetailField
                label="ID type"
                value={beneficiary.details?.idType}
              />
            </Col>
            <Col md={6}>
              <DetailField
                label="ID number"
                value={beneficiary.details?.idNumber}
              />
            </Col>
            <Col md={6}>
              <DetailField
                label="ID expired date"
                value={beneficiary.details?.idExpiredDate}
              />
            </Col>
            <Col md={6}>
              <DetailField
                label="Date of birth"
                value={beneficiary.details?.dob}
              />
            </Col>
          </SectionContainer>

          <SectionContainer title="Personal information">
            <Col md={6}>
              <DetailField
                label="First name"
                value={
                  beneficiary.details?.firstName || beneficiary.name?.split(" ")[0]
                }
              />
            </Col>
            <Col md={6}>
              <DetailField
                label="Middle name"
                value={beneficiary.details?.middleName}
              />
            </Col>
            <Col md={6}>
              <DetailField
                label="Middle initial"
                value={beneficiary.details?.middleInitial}
              />
            </Col>
            <Col md={6}>
              <DetailField
                label="Last name"
                value={beneficiary.details?.lastName || beneficiary.name?.split(" ").slice(1).join(" ")}
              />
            </Col>
            <Col md={6}>
              <DetailField
                label="Name of joint account holder"
                value={beneficiary.details?.jointAccountHolder}
              />
            </Col>
            <Col md={6}>
              <DetailField
                label="Tax identification number"
                value={beneficiary.details?.tin}
              />
            </Col>
            <Col md={6}>
              <DetailField
                label="Company registration number"
                value={beneficiary.details?.companyRegNo}
              />
            </Col>
            <Col md={6}>
              <DetailField
                label="Native name"
                value={beneficiary.details?.nativeName}
              />
            </Col>
          </SectionContainer>
        </Col>

        {/* Right Column */}
        <Col lg={6}>
          <SectionContainer title="Contact information">
            <Col md={12}>
              <DetailField
                label="Contact number"
                value={beneficiary.details?.contactNumber || beneficiary.phone}
              />
            </Col>
          </SectionContainer>

          <SectionContainer title="Address information">
            <Col md={6}>
              <DetailField
                label="Address"
                value={beneficiary.details?.address}
              />
            </Col>
            <Col md={6}>
              <DetailField label="City" value={beneficiary.details?.city} />
            </Col>
            <Col md={6}>
              <DetailField label="State" value={beneficiary.details?.state} />
            </Col>
            <Col md={6}>
              <DetailField
                label="Postal code"
                value={beneficiary.details?.postalCode}
              />
            </Col>
            <Col md={6}>
              <DetailField label="Suburb" value={beneficiary.details?.suburb} />
            </Col>
          </SectionContainer>

          <SectionContainer title="Account details">
            <Col md={6}>
              <DetailField label="Bank" value={beneficiary.details?.bankName || beneficiary.bank} />
            </Col>
            <Col md={6}>
              <DetailField
                label="Cash pickup location"
                value={beneficiary.details?.cashPickupLocation}
              />
            </Col>
            <Col md={6}>
              <DetailField label="IBAN" value={beneficiary.details?.iban} />
            </Col>
            <Col md={6}>
              <DetailField
                label="Account number"
                value={beneficiary.details?.accountNumber}
              />
            </Col>
            <Col md={6}>
              <DetailField
                label="Account type"
                value={beneficiary.details?.accountType}
              />
            </Col>
            <Col md={6}>
              <DetailField
                label="Bank account title"
                value={beneficiary.details?.bankAccountTitle || beneficiary.name}
              />
            </Col>
            <Col md={6}>
              <DetailField
                label="Transit number"
                value={beneficiary.details?.transitNumber}
              />
            </Col>
            <Col md={6}>
              <DetailField
                label="Sort code"
                value={beneficiary.details?.sortCode}
              />
            </Col>
            <Col md={6}>
              <DetailField
                label="Routing number"
                value={beneficiary.details?.routingNumber}
              />
            </Col>
            <Col md={6}>
              <DetailField
                label="BSB number"
                value={beneficiary.details?.bsbNumber}
              />
            </Col>
            <Col md={6}>
              <DetailField
                label="Branch name"
                value={beneficiary.details?.branchName}
              />
            </Col>
            <Col md={6}>
              <DetailField
                label="Branch code"
                value={beneficiary.details?.branchCode}
              />
            </Col>
            <Col md={6}>
              <DetailField
                label="Branch number"
                value={beneficiary.details?.branchNumber}
              />
            </Col>
            <Col md={6}>
              <DetailField
                label="IFSC number"
                value={beneficiary.details?.ifscNumber}
              />
            </Col>
            <Col md={6}>
              <DetailField
                label="SWIFT code"
                value={beneficiary.details?.swiftCode}
              />
            </Col>
            <Col md={6}>
              <DetailField
                label="Institution number"
                value={beneficiary.details?.institutionNumber}
              />
            </Col>
          </SectionContainer>
        </Col>
      </Row>
    </CommonModal>
  );
};

export default BeneficiaryDetailsModal;
